export default {
  state: {
    file: null,
    docid: null,
  },
  mutations: {
    uploadFile(state, payload) {
      state.file = payload
    },
    setDocid(state, payload) {
      state.docid = payload
    }
  },
  actions: {
    uploadFile({commit}, payload) {
      commit('uploadFile', payload)
    },
    setDocid({ commit }, payload) {
      commit('setDocid', payload)
    }
  },
  getters: {
    file(state) {
      return state.file
    },
    docid(state) {
      return state.docid
    }
  }
}